import logoBranco from '../images/logo_branco.png'
import logo from '../images/logo_branco.png'
import iconBranco from '../images/logo_branco.png'

const theme = {
  colors: {
    primary: "#657082",
    primaryHover: "#939aa7",
    primaryDark: "#464e5b",
    secondary: "#657082",
    white: "#FFFFFF",
    gray: "#707070",
    lightGray: "#F2F2F2",
    border: "#1F3D1B",
    background: "#a1a1a3",
    success: "#28a745",
    error: "#dc3545"
},

  
  // Logo configurations
  logos: {
    default: logoBranco,
    white: logoBranco,
    dark: logo,
    icon: iconBranco
  },

  // Typography
  typography: {
    fontFamily: {
      primary: 'Axiforma',
      bold: 'Axiforma Bold',
      light: 'Axiforma Light'
    },
    fontSize: {
      small: '14px',
      medium: '16px',
      large: '18px',
      xlarge: '24px',
      xxlarge: '42px'
    }
  },

  // Border radius
  borderRadius: {
    small: '8px',
    medium: '14px',
    large: '16px'
  }
}

// Add this function to sync theme colors with CSS custom properties
function syncThemeWithCSS(theme) {
  Object.entries(theme.colors).forEach(([key, value]) => {
    document.documentElement.style.setProperty(`--theme-${key}`, value);
  });
}

// Call this function when your app initializes
syncThemeWithCSS(theme);

export default theme 